import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import {
  GetFinancialLimitOptionsEntity,
  UserWalletManageService,
} from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

export const useGetFinancialLimitOptionsQuery = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const queryKey = [UserServiceQueryKeys.GET_FINANCIAL_LIMIT_OPTIONS];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetFinancialLimitOptionsEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletManageService.userManageControllerGetFinancialLimitOptions(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...QUERY_CACHE_CONFIG.REFERENCE_DATA,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
